import 'slick-carousel'
import INTRO from '../modules/intro'
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const slider = {
  obj: '[data-plugin="slider"]',
  animationDuration: 8000,
  init() {
    $(this.obj).slick({
      autoplay: false,
      fade: true,
      dots: false,
      speed: 2000,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false
    })
    $(this.obj).on('beforeChange', (e, slick, cs, ns) => {
      $(`[data-slick-index=${ns}]`).addClass('is-animation-start')
      setTimeout(() => $(`[data-slick-index=${ns}]`).removeClass('is-animation-start'),
        this.animationDuration
      )
    })
  },
  start() {
    $(this.obj).slick('slickPlay').addClass('is-slickPlay')
    $(`[data-slick-index=0]`).addClass('is-animation-start')
    setTimeout(() => $(`[data-slick-index=0]`).removeClass('is-animation-start'),
      this.animationDuration
    )
  }
}

const init = () => {
  // slick実行
  if( w.load['mainvisual'] ) w.load['mainvisual'].then( () => slider.init() )

  // attention
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-attention-item">
        <a href="${item.href}" class="block-attention-item__link">
          <span class="date">${item.date}</span>
          <span class="cate">${item.category.name}</span>
          <span class="subject${item.is_new ? ' is-new': ''}">${item.title.str_truncate(24)}</span>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-attention__list[data-plugin="getArticles"]', { makeItem }).then( items => {
      if(items.length == 0) $('.block-attention').remove();
    });
  });

  // news
  $.when(w.load['block-news']).then( () => {
    let makeItem = item => $(`
      <li class="block-news-item">
        <a href="${item.href}">
          <figure class="block-news-item__img">
            <div class="block-news-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="220" loading="lazy"></div>
          </figure>
          <div class="block-news-item__body">
            <span class="cate">${item.category.name}</span>
            <span class="date">${item.date}</span>
            ${item.is_new ? '<span class="is-new">NEW</span>': ''}
            <span class="subject">${item.title.str_truncate(24)}</span>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-news__list[data-plugin="getArticles"]', { makeItem });
  });


  // facility
  $.when(w.load['block-facility']).then( () => {
    let tagHTML = tags => {
      const $container = $('<ul class="block-facility__tagList"/>')
      if( tags.length > 0 ) {
        $.each( tags, (i, tag) => {
          const tagEncoded =  encodeURI( tag )
          const $item = $(`<li><a href="/facilities/?mode=list&tag=${tagEncoded}">${tag}</a></li>`)
          $item.appendTo( $container )
        })
        return $container[0].outerHTML
      }
    }
    //記事IDでお知らせのカテゴリを取得
    const map_category = {
      1: 2,
      2: 3,
      3: 4,
      4: 5,
      5: 6,
      6: 7,
    }
    let makeItem = item => $(`
      <li class="block-facility-item">
        <a href="${item.href}">
          <div class="block-facilirty-item__inner">
            <figure class="block-facility-item__img">
              <div class="block-facility-item__img-cover" style="background-image:url(/asset/img/home/facility_${item.id}.jpg)"><img src="/asset/img/home/facility_${item.id}.jpg" alt="${item.title}" width="460" loading="lazy"></div>
            </figure>
            <div class="block-facility-item__body">
              <h4 class="block-facility-item__title">${item.title}<svg class="icon" width="18" height="18"><use xlink:href="/asset/svg/sprite.symbol.svg#arrow_right_circle"></use></svg></h4>
              <p>${item.desc}</p>
            </div>
          </div>
          <!-- /.block-facilirty-item__imgWrap -->
        </a>
        <div class="block-facility-item__tagList">
          ${item.keywords.length > 0 ? tagHTML(item.keywords)  : ''}
        </div>
        <div class="block-facility-item__btnWrap">
        ${(map_category[item.id])? `
          <a href="/news/?mode=list&cat=${map_category[item.id]}" class="button button-pill button-arrow-right"><span>お知らせを見る</span></a>
        `: ''}
        </div>
      </li>
    `)[0]
    GET_ARTICLES('.block-facility__list[data-plugin="getArticles"]', { makeItem })
  })

}


export default function HOME() {

  $( init )

  const intro = new INTRO({
    titleText: '三方原台地でくらす',
    duration: [1.5,2,2],
    target: '.mainvisual',
  })
  $(() => {
    $.when( w.load['mainvisual'] ).then( intro.start )
  })
  $.when(
    intro.promise
  ).then(() => slider.start() )

}